import { asyncActionsCreator } from '../../global/redux';
import * as constants from './constants';

// Получить все интеграции
export const getIntegrations = asyncActionsCreator(
  constants.INTEGRATIONS_GET_ALL
);

// Получить интеграцию по коду
export const getIntegrationByCode = asyncActionsCreator(
  constants.INTEGRATIONS_GET_ONE
);

// Создать интеграцию
export const createIntegration = asyncActionsCreator(
  constants.INTEGRATIONS_CREATE
);

// Привязать сеть
export const addNetworkToIntegration = asyncActionsCreator(
  constants.INTEGRATIONS_ADD_NETWORK
);

// Отвязать сеть
export const removeNetworkFromIntegration = asyncActionsCreator(
  constants.INTEGRATIONS_REMOVE_NETWORK
);

// Изменить активность сети
export const setNetworkActive = asyncActionsCreator(
  constants.INTEGRATIONS_SET_NETWORK_ACTIVE
);

// Обновить информацию об интеграции (front_url, sender)
export const updateIntegrationInfo = asyncActionsCreator(
  constants.INTEGRATIONS_UPDATE_INFO
);
